import React from 'react';
import { ReactComponent as FigThumbsUpComponent } from './FigThumbsUp.svg';

const FigThumbsUp = (props) => <FigThumbsUpComponent {...props} />;

export default FigThumbsUp;
